import { FormattedMessage } from 'react-intl';
import Coupon from '@alltrails/core/types/Coupon';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import { getDiscountPercentage } from '@alltrails/payment/utils/plan';
import type Plans from '@alltrails/types/Plans';
import getFreeTrialDurationHeading from './getFreeTrialDurationHeading';

const getHeadingText = ({
  plans,
  coupon,
  tierSelected,
  isNigelEnabled = false
}: {
  plans: Plans;
  coupon?: Coupon;
  tierSelected: PurchaseTier;
  isNigelEnabled?: boolean;
}) => {
  if (coupon?.type === 'FreeTrialCoupon' && coupon.subscriptionTier) {
    return getFreeTrialDurationHeading(coupon, coupon.subscriptionTier);
  }

  if (coupon?.type === 'SubscriptionCoupon') {
    if (coupon.subscriptionTier === 'any' && coupon.discountPercentage) {
      const percent = coupon.discountPercentage / 100;
      return <FormattedMessage defaultMessage="{percent, number, ::percent} off your first year" values={{ percent }} />;
    }

    if (coupon.subscriptionTier === 'peak') {
      const percent = getDiscountPercentage(plans.peak, coupon) / 100;
      return <FormattedMessage defaultMessage="Get Peak for {percent, number, ::percent} off" values={{ percent }} />;
    }

    if (coupon.subscriptionTier === 'plus') {
      const percent = getDiscountPercentage(plans.plus, coupon) / 100;

      return <FormattedMessage defaultMessage="Get Plus for {percent, number, ::percent} off" values={{ percent }} />;
    }
  }

  switch (tierSelected) {
    case 'peak':
      if (isNigelEnabled) {
        return <FormattedMessage defaultMessage="Go further with advanced planning tools" />;
      }
      return <FormattedMessage defaultMessage="Get custom routes and advanced planning tools" />;
    case 'plus':
      return <FormattedMessage defaultMessage="Get Offline Maps and more trail essentials" />;
  }
};

export default getHeadingText;
